import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute } from '@angular/router';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import 'rxjs/add/operator/map';
import { User } from '../data-models/user.class';


@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor( private auth: AuthService, private router: Router, 
    private aroute: ActivatedRoute) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean>|boolean {
   
      const currentUser:User = this.auth.currentUserValue();                    
      //console.log(currentUser);
      //console.log(route.data);
      if (route.data.roles.indexOf(currentUser.role)>-1) {
        return true;
      }
      this.router.navigate(['/dashboard']);
      // this.router.navigate(['/'], { queryParams: { returnUrl:'dashboard' }});
      return false;
    }
}
